// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"4e3d3236","229":"4bea85ea","422":"5f0e8863"}[chunkId] + ".chunk.js";
};